require('./dist/angular-gettext.js');
module.exports = 'gettext';



//////////////////
// WEBPACK FOOTER
// ./~/angular-gettext/index.js
// module id = 11
// module chunks = 0